import * as Yup from 'yup'
import { Form,Col } from 'react-bootstrap'
import { CustomFormControl,CustomFormSelect } from '../../../../StyledComponents';
import { Options } from '../SelectOptions';

export const Schema = (settings) => Yup.object().shape({
    salaryRequest: Yup.number()
        .nullable(true)
        .typeError("Nur Zahlenwerte ohne Sonderzeichen")
        .positive("Nur positive Zahlen")
        .integer("Nur ganze Zahlen")
        .test("Length", "Zahl ist zu groß", val => {
            if (val) return val <= 999999;
            return true;
        }),
    workTime: Yup.number()
        .nullable(true)
        .typeError("Nur Zahlenwerte ohne Sonderzeichen")
        .positive("Nur positive Zahlen")
        .integer("Nur ganze Zahlen"),
});

export const PersonalDataSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            
           
            
            
            
            <Form.Group className="mb-2">
            Möchten Sie, dass wir Sie in unserer Datenbank auch für andere Positionen berücksichtigen?
            </Form.Group>
                {
                    Options.OtherPositions.map((field, index) =>
                        <Form.Group className="mb-3" key={index}>
                            <Form.Check
                                type="radio"
                                name="otherPositionsOption"
                                id={field.value}
                                label={field.value}
                                value={1 - index}
                                feedback={errors.otherPositionsOption}
                                feedbackType="invalid"
                                isValid={touched.otherPositionsOption && !errors.otherPositionsOption}
                                isInvalid={errors.otherPositionsOption}
                                onChange={(event) => {
                                    handleChange(event);
                                }}
                            >
                            </Form.Check>
                        </Form.Group>
                    )
                }

                <Form.Group className="mb-3" controlId="formremarks">
                <Form.Label>Bemerkungen</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Bemerkungen"
                    type="text"
                    name="remarks"
                    value={values.remarks}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.remarks && !errors.remarks}
                    isInvalid={touched.remarks && errors.remarks}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.remarks}
                </Form.Control.Feedback>
            </Form.Group>    
             </>
             
    );
};